import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Label from "../../common/primitives/Label";

import styles from './CartLines.scss';

import helpers from "../../common/scss/helpers/_helpers.scss";
import buttons from "../../common/primitives/Button.scss";
import removeImg from './img/remove.png';
import Price, {ConvertToEUR} from "../../common/primitives/Price";
import LoadingRow from "../../common/primitives/LoadingRow";
import TextBox from "../../common/primitives/TextBox";
import Button from "../../common/primitives/Button";
import Tooltip from "../../common/primitives/Tooltip";
import {__t} from '../../common/lang/text-resource';
import {_validateDomainNameSimple} from '../../common/helpers/HelperValidator';

const CartLineWPSupport = ({
							   data,
							   taxonomy,
							   removeService,
							   changeServiceTerm,
							   childServices,
							   showAsPage,
							   setWPSupportDomainName
						   }) => {
	const {
		id,
		serviceName,
		serviceNameOrig,
		serviceTypeName,
		serviceId,
		priceData,
		servicePriceId,
		discountPriceList,
		discountPromo,
		discountTerm,
		isNewService,
		isRenewService,
		canDelete,
		isFree,
		term,
		oldPrice,
		price,
		currency,
		priceOrig,
		priceTopOrig,
		loading,
		cartItemName,
		accountName
	} = data;

	let supportDomainName = '';
	try {
		_validateDomainNameSimple(cartItemName);
		supportDomainName = cartItemName;
	} catch (e) {
		supportDomainName = '';
	}
	const [showInputField, setShowInputField] = useState(supportDomainName === '');
	useEffect(() => {

		try {
			_validateDomainNameSimple(cartItemName);
			supportDomainName = cartItemName;
		} catch (e) {
			supportDomainName = '';
		}
		setShowInputField(supportDomainName === '');
	}, [cartItemName])

	let canDeleteInner = canDelete;

	if ((serviceId === 'wp_support_01') && isRenewService) {
		canDeleteInner = false;
	}

	if (loading) {
		return (
		  <section className={showAsPage ? styles.asPage : ''}>
			  <div
				data-layout={`row gutter-none start ${!showAsPage ? 'margin-bottom--xs padding-bottom--xxs' : ''}`}>
				  <div data-layout='col 12 text-center'>
					  <div className={styles.loadingContainer}>
						  <LoadingRow/>
					  </div>
				  </div>
			  </div>
		  </section>
		)
	}

	return (
	  <section className={showAsPage ? styles.asPage : ''}>
		  <div data-layout={`row gutter-none start ${!showAsPage ? 'margin-bottom--xs padding-bottom--xxs' : ''}`}>
			  <div
				className={styles.removeContainer}
				data-layout={`padding-top--xxs ${!showAsPage ? 'padding-left--xs col 1' : ''}`}>
				  {
					canDeleteInner === true &&
					<button data-layout={!showAsPage ? 'margin-left--xxs' : ''}
							className={`${buttons.buttonImage} ${styles.removeButton}`}
							onClick={() => removeService(id, serviceId, serviceName)}>
						<img src={removeImg} alt={__t("Remove")}/>
					</button>
				  }
			  </div>
			  <div data-layout={`col 11 text-left padding-left--xs ${showAsPage ? '5@md' : ''}`}>
				  <Label
					htmlFor={id}
					text={`${serviceNameOrig}`}
					className={`${helpers.orderServiceName} ${!showAsPage ? styles.asPageServiceName : ''}`}/>
			  </div>
			  <div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
			  <div data-layout={`col 11 margin-top--xs padding-left--xs ${showAsPage ? '6@md' : ''}`}>
				  {
					  isFree ?
						<table className={styles.selectedPriceContainer}>
							<tbody>
							<tr>
								<td>{term}</td>
								<td className={styles.oldPrice}>
									{
										oldPrice !== price ? oldPrice : null
									}
									{SHVO.showEuroPrices && <>
										<br/>
										{
											oldPrice !== price ? ConvertToEUR(oldPrice) : null
										}
									</>}
								</td>
								<td>
									<Price
									  currency={currency}
									  value={priceOrig}
									  currencyClass={styles.currency}/>
									{SHVO.showEuroPrices && <>
										<br/>
										<Price
										  currency={'EUR'}
										  value={ConvertToEUR(priceOrig)}
										  currencyClass={styles.currency}/>
									</>}
								</td>
								<td data-layout="padding-right--md">&nbsp;</td>
							</tr>
							</tbody>
						</table>

						:


						showAsPage === true ?
						  /*<SelectPrice
							  name={id}
							  newPriceCol="price"
							  valueCol="priceId"
							  labelCol="term"
							  options={priceData}
							  oldPriceCol="oldPrice"
							  currencyCol="currency"
							  selected={servicePriceId}
							  onChange={changeServiceTerm}
							  onMenuOpen={() => {
								  HelperGoogleAnalytics.TrackServicePriceSelectorOpen(taxonomy, isNewService);
								  HelperGoogleAnalytics4.TrackServicePriceSelectorOpen(taxonomy, isNewService);
							  }}/>*/
						  <table className={styles.selectedPriceContainer}>
							  <tbody>
							  <tr>
								  <td>{term}</td>
								  <td className={styles.oldPrice}>
									  {
										  priceTopOrig !== priceOrig ? priceTopOrig : null
									  }
									  {SHVO.showEuroPrices && <>
										  <br/>
										  {
											  priceTopOrig !== priceOrig ? ConvertToEUR(priceTopOrig) : null
										  }
									  </>}
								  </td>
								  <td>
									  <Price
										currency={currency}
										value={priceOrig}
										currencyClass={styles.currency}/>
									  {SHVO.showEuroPrices && <>
										  <br/>
										  <Price
											currency={'EUR'}
											value={ConvertToEUR(priceOrig)}
											currencyClass={styles.currency}/>
									  </>}
								  </td>
								  <td data-layout='padding-right--md'>&nbsp;</td>
							  </tr>
							  </tbody>
						  </table>
						  :
						  <table className={styles.selectedPriceContainer}>
							  <tbody>
							  <tr>
								  <td>{term}</td>
								  <td className={styles.oldPrice}>
									  {
										  priceTopOrig !== priceOrig ? priceTopOrig : null
									  }
									  {SHVO.showEuroPrices && <>
										  <br/>
										  {
											  priceTopOrig !== priceOrig ? ConvertToEUR(priceTopOrig) : null
										  }
									  </>}
								  </td>
								  <td>
									  <Price
										currency={currency}
										value={priceOrig}
										currencyClass={styles.currency}/>
									  {SHVO.showEuroPrices && <>
										  <br/>
										  <Price
											currency={'EUR'}
											value={ConvertToEUR(priceOrig)}
											currencyClass={styles.currency}/>
									  </>}
								  </td>
								  <td data-layout='padding-right--md'>&nbsp;</td>
							  </tr>
							  </tbody>
						  </table>

				  }
			  </div>
		  </div>
		  <div data-layout="row gutter-none start" className={styles.discountsWrapper}>

			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  {/*Редове с отстъпки начало*/}
			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  <div className={styles.rightAtTabPage} data-layout={`col 12 ${showAsPage ? '6@md' : ''}`}>
				  {
					  (discountPriceList > 0 && discountPromo < 100) ?
						<div data-layout="row gutter-none middle">
							<div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
							<div
							  data-layout="col 11 margin-top--xs padding-left--xs text-left"
							  className={helpers.orderServiceDiscount}>
								{__t('–-discountPriceList%-допълнителна-партньорска-отсdf8ebf', {discountPriceList: discountPriceList})}
							</div>
						</div>
						: ''
				  }

				  {
					  (discountPromo > 0) ?
						<div data-layout="row gutter-none middle">
							<div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
							<div
							  data-layout="col 11 margin-top--xs padding-left--xs text-left"
							  className={helpers.orderServiceDiscount}>
								{__t('–:discountPromo% отстъпка от промокод', {discountPromo: discountPromo})}
							</div>
						</div>
						: ''
				  }

				  {
					  (discountTerm > 0 && discountPromo < 100) ?
						<div data-layout="row gutter-none middle">
							<div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
							<div
							  data-layout="col 11 margin-top--xs padding-left--xs text-left"
							  className={helpers.orderServiceDiscount}>
								{isRenewService ? __t('–:discountTerm% промоционална отстъпка', {discountTerm: discountTerm}) : __t('–:discountTerm% отстъпка за нова услуга', {discountTerm: discountTerm})}
							</div>
						</div>
						: ''
				  }
			  </div>
			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  {/*Редове с отстъпки край*/}
			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  {
				  showAsPage ? <div className={styles.removeContainer} data-layout="first@md"/> : ''
			  }
			  <div data-layout={`col 12 ${showAsPage ? '5@md first@md' : ''}`}>
				  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				  {/*Основен домейн начало*/}
				  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				  <div data-layout="row gutter-none middle margin-top--xxs">
					  <div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
					  <div
						data-layout="col 11 margin-top--xs padding-left--xs text-left">
						  {
							isNewService && supportDomainName !== '' &&
							<React.Fragment>
								{__t('За:')}&nbsp;<Button
							  className={`${buttons.buttonLink} ${buttons.action}`}
							  onClick={() => setShowInputField(true)}
							  value={supportDomainName}/>
							</React.Fragment>
						  }
						  {
							  isRenewService ? __t('За: :accountName', {accountName: accountName}) : ''
						  }
					  </div>
				  </div>
				  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				  {/*Основен домейн край*/}
				  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}

			  </div>
		  </div>
		  {
			showInputField && isNewService &&
			<WPSupportDomainName
			  domainName={supportDomainName}
			  setWPSupportDomainName={setWPSupportDomainName}
			  serviceId={serviceId}
			  lineId={id}/>
		  }
	  </section>
	);

};

const WPSupportDomainName = ({domainName, lineId, setWPSupportDomainName, serviceId}) => {

	const [value, setValue] = useState(domainName);

	return (
	  <div data-layout="row gutter-none middle margin-top--xxs"
		   className={`${styles.wpSupportDomainNameContainer} ${domainName === '' ? styles.withoutDomainName : ''}`}>
		  <div className={styles.removeContainer} data-layout='col 1 margin-top--sm'>

		  </div>
		  <div
			className={styles.childServiceContainer}
			data-layout={`col 11 margin-top--smm padding-left--xs text-left`}>
			  <p>{__t('Посочете домейн за WP поддръжката:')}</p>
			  <div className={styles.wpSupportInputContainer}>
				  <div className={styles.tooltipAndWPSupportInput}>
					  <Tooltip wider={true}>
						  {__t('това-е-сайтът-за-който-поръчвате-услугата-професиba1ce9')}
					  </Tooltip>
					  <TextBox
						value={value}
						name={'wpsupport_domain_name'}
						placeholder={'mydomain.com'}
						onChange={({target}) => setValue(target.value)}/>
				  </div>
				  <div className={styles.buttonContainer}>
					  <Button onClick={() => setWPSupportDomainName(lineId, value)} value={__t('Запази')}/>
				  </div>
			  </div>
		  </div>
	  </div>
	)
}


CartLineWPSupport.propTypes = {
	data: PropTypes.shape({
		id: PropTypes.string.isRequired,
		serviceId: PropTypes.string.isRequired,
		serviceName: PropTypes.string.isRequired,
		serviceTypeName: PropTypes.string.isRequired,
		servicePriceId: PropTypes.string.isRequired,
		isNewService: PropTypes.bool,
		isRenewService: PropTypes.bool,
		isFree: PropTypes.bool,
		canDelete: PropTypes.bool,
		term: PropTypes.string,
		oldPrice: PropTypes.string,
		price: PropTypes.string,
		currency: PropTypes.string,
		priceOrig: PropTypes.string,
		mainDomainData: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({
			domainTLD: PropTypes.string,
			isCyrillic: PropTypes.bool,
			lineId: PropTypes.string,
			name: PropTypes.string,
		})]),
		priceData: PropTypes.arrayOf(
		  PropTypes.shape({
			  currency: PropTypes.string,
			  oldPrice: PropTypes.string,
			  price: PropTypes.string,
			  priceId: PropTypes.string,
			  term: PropTypes.string,
		  })
		),
		discountPriceList: PropTypes.number,
		discountPromo: PropTypes.number,
		discountTerm: PropTypes.number,
	}),
	taxonomy: PropTypes.object,
	removeService: PropTypes.func.isRequired,
	changeServiceTerm: PropTypes.func.isRequired,
	showAsPage: PropTypes.bool
};

export default CartLineWPSupport;